import AdvanceApprovedScreen from 'features/advance/screens/advanceStatusScreens/AdvanceApproved/AdvanceApprovedCongratsScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

const Approved = () => {
  return (
    <PinwheelContextProvider>
      <AdvanceApprovedScreen />
    </PinwheelContextProvider>
  );
};

export default Approved;
